import { useEffect, useState } from 'react'
import { bookmakerApi, bmErrorMessage } from '@/api/bookmaker'
import { BmJsonCard, BmPage } from './BmPage'

export function CompetitionPage() {
  const [data, setData] = useState<unknown>(null)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    void bookmakerApi
      .competitionList({})
      .then(setData)
      .catch((e) => setError(bmErrorMessage(e)))
  }, [])
  return (
    <BmPage title="Competition" description="Lab /competition" error={error}>
      <BmJsonCard title="Competitions" data={data} />
    </BmPage>
  )
}
